<template lang="html">
  <multiselect
    class="simple-select big"
    v-model="innerValue"
    :options="options"
    label="label"
    track-by="value"
    :searchable="true"
    :allow-empty="allowEmpty"
    :show-labels="false"
  />
</template>

<script>
  export default {
    name: 'simple-select',

    props: {
      value: Object,
      options: Array,
      onChange: Function,
      allowEmpty: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      innerValue: {
        get () {
          return this.value
        },

        set (val) {
          this.onChange && this.onChange(val)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .simple-select {
    ::v-deep.multiselect__tags {
      border-radius: 4px;
    }

    ::v-deep.multiselect__content-wrapper {
      border-radius: 4px;
    }
  }
</style>
